<template lang="pug">
div
	div(v-show='capturing').pad-bottom
		video#video(style='width:100%')
		
		div.pad
			section.flex(v-if='capturing')
				div.flex-min
					button.button.is-large.is-fullwidth.is-light(@click='flip_camera')
						font-awesome-icon(icon='sync') 
				div.flex-grow
					button.button.is-large.is-fullwidth.is-success(@click='take_picture') 
						font-awesome-icon(icon='camera') 
						span Take photo
					
	div(v-show='captured').pad-bottom
		canvas(style='border: 10px solid green; width:100%')#selfie
		div.pad
			button.button.is-large.is-fullwidth.is-light(@click='capturing = true;captured=false') Retake
		
	div(v-show='!capturing && !captured').pad
		h3 Your picture is required for survey response.
		button.button.is-large.is-fullwidth.is-light(@click='start_video') 
			font-awesome-icon(icon='portrait') 
			span(style="margin-left: 1rem;") Click to capture photo
	p.alert.alert-danger(v-if='capture_error') Your device does not support photo capture.
	hr
</template>

<script>
export default {
  name: "Selfie",
  data: function() {
    return {
      captured: false,
      capturing: false,
      capture_error: false,
      video: null,
      facingMode: "environment"
    };
  },
  computed: {},
  props: {},
  mounted: function() {
    this.video = this.$el.querySelector("#video");
  },
  methods: {
    start_video() {
      this.video.style.width = document.width + "px";
      this.video.style.height = document.height + "px";
      this.video.setAttribute("autoplay", "");
      this.video.setAttribute("muted", "");
      this.video.setAttribute("playsinline", "");
      const on_success = stream => {
        this.video.srcObject = stream;
        this.video.play();
        this.capturing = true;
      };
      const on_fail = () => {
        this.capture_error = true;
      };
      this.video.pause();
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              facingMode: this.facingMode
            }
          })
          .then(on_success)
          .catch(on_fail);
      } else {
        // not a newer version of chrome - could be another browser or something older
        navigator.getUserMedia =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia ||
          navigator.mediaDevices.getUserMedia;
        if (!navigator.getUserMedia) {
          this.capture_error = true;
        } else {
          navigator.getUserMedia(
            {
              video: {
                facingMode: this.facingMode
              }
            },
            on_success,
            on_fail
          );
        }
      }
    },
    take_picture() {
      const hidden_canvas = this.$el.querySelector("#selfie");
      const context = hidden_canvas.getContext("2d");

      const width = this.video.videoWidth;
      const height = this.video.videoHeight;

      if (width && height) {
        // Setup a canvas with the same dimensions as the video.
        hidden_canvas.width = width;
        hidden_canvas.height = height;

        // Make a copy of the current frame in the video on the canvas.
        context.drawImage(this.video, 0, 0, width, height);

        // Turn the canvas image into a dataURL that can be used as a src for our photo.
        this.$emit("selfie", hidden_canvas.toDataURL("image/png"));
        this.captured = true;
      }
      this.capturing = false;
    },
    flip_camera() {
      this.facingMode = this.facingMode == "user" ? "environment" : "user";
      this.start_video();
    }
  }
};
</script>

<style scoped lang="less">
.flex-min {
  margin-right: 1rem;
}
h3 {
  text-align: left;
  padding-left: 0.5rem;
}
.pad {
  padding: 0.5rem;
}
</style>